export default __webpack_public_path__ + "static/media/190629_190332_IMG_5454.86649ef1.jpg";